export const Document = {
    path: '/documents',
    name: 'documents',
    component: () => import('@/views/Edms/Document/DocumentPage.vue'),
}